import { Type } from '@angular/core';
import { QuestionType } from '@empathy/survey/base';

import { AIChatFormComponent } from '../components/question-type-form-components/ai-chat-form/ai-chat-form.component';
import { CarouselFormComponent } from '../components/question-type-form-components/carousel-form/carousel-form.component';
import { CarouselRatingFormComponent } from '../components/question-type-form-components/carousel-rating-form/carousel-rating-form.component';
import { ChoicesFormComponent } from '../components/question-type-form-components/choices-form/choices-form.component';
import { FileUploadFormComponent } from '../components/question-type-form-components/file-upload-form/file-upload-form.component';
import { HeatmapFormComponent } from '../components/question-type-form-components/heatmap-form/heatmap-form.component';
import { HiddenChoicesFormComponent } from '../components/question-type-form-components/hidden-choices-form/hidden-choices-form.component';
import { InfoFormComponent } from '../components/question-type-form-components/info-form/info-form.component';
import { NPSFormComponent } from '../components/question-type-form-components/nps-form/nps-form.component';
import { QuestionTermsFormComponent } from '../components/question-type-form-components/question-terms-form/question-terms-form.component';
import { RankSortFormComponent } from '../components/question-type-form-components/rank-sort-form/rank-sort-form.component';
import { RankingFormComponent } from '../components/question-type-form-components/ranking-form/ranking-form.component';
import { RatingValuesFormComponent } from '../components/question-type-form-components/rating-values-form/rating-values-form.component';

export const QuestionTypeFormComponent: Record<QuestionType, Type<any>> = {
  [QuestionType.SingleChoice]: ChoicesFormComponent,
  [QuestionType.MultiChoice]: ChoicesFormComponent,
  [QuestionType.Input]: QuestionTermsFormComponent,
  [QuestionType.Carousel]: CarouselFormComponent,
  [QuestionType.CarouselMultiChoice]: CarouselFormComponent,
  [QuestionType.CarouselRating]: CarouselRatingFormComponent,
  [QuestionType.Rating]: RatingValuesFormComponent,
  [QuestionType.Dropdown]: ChoicesFormComponent,
  [QuestionType.Essay]: QuestionTermsFormComponent,
  [QuestionType.Heatmap]: HeatmapFormComponent,
  [QuestionType.InfoPage]: InfoFormComponent,
  [QuestionType.FileUpload]: FileUploadFormComponent,
  [QuestionType.Terminate]: undefined,
  [QuestionType.HiddenChoice]: HiddenChoicesFormComponent,
  [QuestionType.AIChat]: AIChatFormComponent,
  [QuestionType.NPS]: NPSFormComponent,
  [QuestionType.Ranking]: RankingFormComponent,
  [QuestionType.RankSort]: RankSortFormComponent
};
